import { jsxs as n, jsx as i } from "react/jsx-runtime";
import e from "./index.es5511.js";
import f from "classnames";
import { Heading as h } from "./index.es489.js";
import { Button as s } from "./index.es11.js";
const y = "inlined-edit-menu-container", T = ({
  children: c,
  footer: o,
  header: l,
  testId: d = y
}) => {
  const { submit: a, cancel: t, layout: r = "fill" } = o || {}, m = f(e.footer, e[r]), { title: p, Icon: N } = l || {};
  return /* @__PURE__ */ n("div", { "data-testid": d, className: e.root, children: [
    l && /* @__PURE__ */ n("header", { className: e.header, children: [
      N,
      /* @__PURE__ */ i(h, { variant: "h6", children: p })
    ] }),
    /* @__PURE__ */ i("div", { className: e.content, children: c }),
    o && /* @__PURE__ */ n("footer", { className: m, "data-layout": r, children: [
      t && /* @__PURE__ */ i(
        s,
        {
          size: "small",
          variant: "secondary-gray",
          fullWidth: r !== "space",
          ...t,
          children: (t == null ? void 0 : t.text) || "Cancel"
        }
      ),
      /* @__PURE__ */ i(
        s,
        {
          size: "small",
          variant: "primary-gray",
          fullWidth: r !== "space",
          ...a,
          children: (a == null ? void 0 : a.text) || "Apply"
        }
      )
    ] })
  ] });
};
export {
  T as InlineEditMenuContainer
};
//# sourceMappingURL=index.es764.js.map
